var STAGE = true;

/*
  Main
*/
var PAGE_CODE = $("body").attr("data-code");
var BO_ID = 6;


$(document).ready(function() {
  $("img").unveil();
});

var mobileHover = function () {
    $('*[mobile-hover]').on('touchstart', function () {
        $(this).trigger('hover');
    }).on('touchend', function () {
        $(this).trigger('hover');
    });
};
mobileHover();


/************************************************
                        TOOLS
*************************************************/
function in_array(needle, haystack) {
  for(var i in haystack) {
      if(haystack[i] == needle) return true;
  }
  return false;
}


function getURLParam(strParamName) {
  var strReturn = '';
  var strHref = window.location.href;

  if ( strHref.indexOf('?') > -1 ) {
    var strQueryString = strHref.substr(strHref.indexOf('?'));
    var aQueryString = strQueryString.split('&');
    for (var iParam = 0; iParam < aQueryString.length; iParam++) {

      if (aQueryString[iParam].indexOf(strParamName + '=') > -1 ) {

        var aParam = aQueryString[iParam].split('=');
        strReturn = aParam[1];
        break;
      }
    }
  }
  else if (strHref.indexOf(strParamName) > -1) {
     strReturn = strHref.substr(strHref.indexOf(strParamName) + 5, 1);
  }
  return unescape(strReturn);
}


/**
 * matchRegex
 * @param {STRING} source
 * @param {STRING} regex_string - fully escaped regex string whithout boundaries nor modifier
 * @return {ARRAY} list of matched capturing groups
 */
function matchRegex(source, regex_string) {
  //-- init
  var founds = [];
  //-- regex obj
  var regex = new RegExp(regex_string, "g");
  //-- first found group
  var found = regex.exec(source);
  //-- loop on source to gather all groups (exec gets only one group at a time)
  while(found !== null) {
    founds.push(found[1]);
    found = regex.exec(source);
  }
  return founds;
}

/**
 * daysInMonth
 * @param {INT} month
 * @param {INT} year
 * @return {INT} Date - number of days
 */
function daysInMonth(month,year) {
  return new Date(year, month, 0).getDate();
}

/**
 * daysInCurrentMonth
 * @return {INT} Date - number of days
 */
function daysInCurrentMonth() {
  var today = new Date();
  var month = today.getMonth();
  var year = today.getFullYear();
  return new Date(year, month, 0).getDate();
}
